import { api } from './client';

export interface InputRecord {
  id: string;
  kind: string;
  input: unknown;
  output: unknown;
  aiCalls: Array<{ model: string; system: string; user: string; content: string }>;
  status: string;
  errorCode: string | null;
  createdAt: string;
  parentIds: string[];
}

export async function savePastedInput(text: string, html?: string) {
  const { data } = await api.post<{ sourceRecordId: string }>('/input-records/paste', { text, html });
  return data;
}

export async function getInputRecords(entity: { payeeId: string } | { applicationId: string }) {
  const { data } = await api.post<{ records: InputRecord[] }>('/input-records/get', entity);
  return data.records;
}
